"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.counterweightSentence = counterweightSentence;
/**
 * Which buckets paid for an edit, in the words both Forecast notices show
 * (BEN-141 FP-018).
 *
 * Pushing one bucket's share up counterweights the others (allocationMechanics),
 * and the notice said "Your other buckets came down to keep the total at 100%."
 * Walked, only Groceries had moved: a user who checked the other three saw them
 * unchanged and had to hunt for the one that paid. It now names them, with their
 * new shares. Each client formats the percentages (`formatPct`) and passes only
 * the buckets whose share changed, read live after the edit.
 *
 * "Came down" is always the direction. `counterweightAllocation`
 * (allocationMechanics.ts) leaves the others untouched while the set is at or
 * under the ceiling, and over it apportions a SMALLER total across them in
 * proportion, so no other share can rise: lowering a bucket never raises another
 * (the remainder stays unallocated).
 */
function counterweightSentence(moved) {
    if (moved.length === 0)
        return "";
    if (moved.length === 1) {
        return `${moved[0].name} came down to ${moved[0].pct}% to keep the total at 100%.`;
    }
    const items = moved.map((m) => `${m.name} (${m.pct}%)`);
    const list = `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
    return `${list} came down to keep the total at 100%.`;
}
//# sourceMappingURL=counterweightCopy.js.map